var _getGlobalLookup;
import { ILocaleKey } from "@faire/web-api/indigofair/locale/ILocaleKey";
import { getGlobalLookup } from "@faire/web/common/globals/lookup";
export var availableLanguageSelectorLocales = (_getGlobalLookup = getGlobalLookup()("availableLanguageSelectorLocales")) !== null && _getGlobalLookup !== void 0 ? _getGlobalLookup : [ILocaleKey.build({
  country: "USA",
  language: "ENG"
})];